/**
 * Drapeaux locaux propres au compte connecté : plusieurs utilisateurs partagent souvent le
 * même navigateur, et ce qu'un éleveur a vu ne vaut pas pour le suivant.
 */
import { AccountStorage } from "../generated/types";

/** Identifiant du compte pour le scope. `anon` si le storage est illisible. */
export const accountKey = (): string => {
  try {
    const raw = localStorage.getItem("accountStorage");
    const email = raw
      ? (JSON.parse(raw) as Partial<AccountStorage>).email
      : undefined;
    return email || "anon";
  } catch {
    return "anon";
  }
};

export const hasAccountFlag = (name: string): boolean => {
  try {
    return !!localStorage.getItem(`${name}:${accountKey()}`);
  } catch {
    return false;
  }
};

export const setAccountFlag = (name: string) => {
  try {
    localStorage.setItem(`${name}:${accountKey()}`, "1");
  } catch {
    // Navigation privée ou storage plein : le drapeau se reposera, rien de bloquant.
  }
};
